import React from 'react';
import {Segment, List} from 'semantic-ui-react';
import {base} from '../helper/base-helper.js';

class ResultRequirements extends React.Component {
  constructor() {
    super();

    this.state = {
      reqTypes: {}
    }
  }

  componentWillMount() {
    this.ref = base.syncState(`/reqtypes`,{
      context: this,
      state: 'reqTypes'
    });
  }

  componentWillUnmount() {
    base.removeBinding(this.ref);
  }

  renderRequirementItem = (key) => {
    const reqObj = this.props.requirements[key];
    const iconName = this.state.reqTypes[reqObj.reqTypeId].icon;
    return (
      <List.Item key={key}>
        <List.Icon
          circular
          name={iconName}
          size='large'
          className='listIcon'
        />
        <List.Content>
          <List.Header>{reqObj.name}</List.Header>
          <List.Description>{reqObj.descr}</List.Description>
        </List.Content>
      </List.Item>
    )
  };

  render() {
    return (
      <Segment attached loading={this.props.loading}>
        <List celled relaxed>
          {
            Object.keys(this.props.requirements).map(this.renderRequirementItem)
          }
        </List>
      </Segment>
    );
  }

}

export default ResultRequirements;



// WEBPACK FOOTER //
// ./src/components/ResultRequirements.js